import AddSubscriptionModel from './models/AddSubscriptionModel';
import GetSubscriptionModel from './models/GetSubscriptionModel';
import EditSubscriptionModel from './models/EditSubscriptionModel';

const AddSubscriptionStore = {
  name: 'AddSubscriptionStore',
  spec: AddSubscriptionModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  }
};
const GetSubscriptionStore = {
  name: 'GetSubscriptionStore',
  spec: GetSubscriptionModel,
  saveLocally: false,
  initialState: {
    sku: '',
    name: '',
    price: 0,
    currency: '',
    active: false,
    tenure: '',
    productCode: '',
    description: '',
    isbns: [],
    vetIsbns: [],
  }
};
const EditSubscriptionStore = {
  name: 'EditSubscriptionStore',
  spec: EditSubscriptionModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  },
};

const stores = [AddSubscriptionStore, GetSubscriptionStore, EditSubscriptionStore]

export default stores;